export default "__VITE_ASSET__BPFGvSqf__"